module.exports = __webpack_public_path__ + "img/menu3.c8488ef3.png";